(function () {

  var SHEET_ID   = "1TLsS0gnoaEoagfieW49cj3FWjOSCizPu20K-u3jJhuY";
  var SHEET_NAME = "CeX Prices";

  var GRADE_META = {
    'Unlocked A': { label: 'A - Excellent', cls: 'gr-a' },
    'Unlocked B': { label: 'B - Good',      cls: 'gr-b' },
    'Unlocked C': { label: 'C - Fair',      cls: 'gr-c' }
  };

  var GRADE_CHECKS = {
    'gr-a': ['Screen has no scratches or cracks', 'Body has no dents or damage', 'All features working (Face/Touch ID, cameras)', 'Battery health over 80%'],
    'gr-b': ['Screen has only light scratches', 'Body has minor scuffs or marks', 'All functions working fine', 'No major damage anywhere', 'Battery health over 80%'],
    'gr-c': ['Screen has visible scratches', 'Body has noticeable scuffs or dents', 'All functions still working', 'No cracked screen or broken parts', 'Battery health over 80%']
  };

  var products      = [];
  var allModels     = [];
  var premiumModels = [];
  var selModel      = null;
  var selStorage    = null; // null = not yet chosen; '' = no storage for this model
  var selGrade      = null;
  var currentQuote  = null;

  /* ---- HELPERS ---- */

  // Returns true if a storage value is a size (MM/CM) rather than GB/TB
  function isSizeVariant(s) {
    return /^\d+(MM|CM)$/i.test(s);
  }

  // Strips gviz callback wrapper robustly regardless of prefix length
  function stripGviz(text) {
    return text.replace(/^[^(]*\(/, '').replace(/\);?\s*$/, '');
  }

  /* ---- LOAD DATA ---- */

  function loadPremium() {
    var url = 'https://docs.google.com/spreadsheets/d/' + SHEET_ID + '/gviz/tq?tqx=out:json&sheet=Premium%20Models';
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var j = JSON.parse(stripGviz(t));
        premiumModels = j.table.rows
          .map(function (r) { return r.c[0] && r.c[0].v ? r.c[0].v.trim() : ''; })
          .filter(function (v) { return v && v !== 'model'; });
      })
      .catch(function () { premiumModels = []; });
  }

  function init() {
    var url = 'https://docs.google.com/spreadsheets/d/' + SHEET_ID + '/gviz/tq?tqx=out:json&sheet=' + encodeURIComponent(SHEET_NAME);
    Promise.all([fetch(url).then(function (r) { return r.text(); }), loadPremium()])
      .then(function (results) {
        var j = JSON.parse(stripGviz(results[0]));
        products  = parseSheet(j);
        var seen  = {};
        allModels = [];
        products.forEach(function (p) { if (p.model && !seen[p.model]) { seen[p.model] = true; allModels.push(p.model); } });
        allModels.sort();
        document.getElementById('ti-loading').style.display = 'none';
        document.getElementById('ti-steps').style.display   = 'block';
        setNum(1, 'active');
      })
      .catch(function () {
        document.getElementById('ti-loading').innerHTML =
          '<p style="font-size:14px;font-weight:700;color:#0f1923;margin-bottom:8px;">Couldn\'t load prices</p>' +
          '<p style="font-size:13px;color:#6b8499;margin-bottom:18px;">Please refresh to try again.</p>' +
          '<button onclick="location.reload()" style="padding:10px 24px;background:#E60D67;color:#fff;border:none;border-radius:999px;font-family:Poppins,sans-serif;font-size:12px;font-weight:700;cursor:pointer;">Retry</button>';
      });
  }

  function parsePrice(v) {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return v;
    return parseFloat(String(v).replace(/[^0-9.]/g, '')) || 0;
  }

  function parseSheet(j) {
    var headers = j.table.cols.map(function (c) { return (c.label || c.id || '').trim(); });
    var data    = [];
    j.table.rows.forEach(function (row) {
      if (!row.c) return;
      var obj = {};
      row.c.forEach(function (cell, i) {
        var h = headers[i];
        if (!h) return;
        var v = cell ? (cell.v !== null && cell.v !== undefined ? cell.v : '') : '';
        if (h === 'sellPrice' || h === 'cashPrice' || h === 'exchangePrice') v = parsePrice(v);
        obj[h] = v;
      });

      // FIX 1: only require model + grade — storage can be empty for AirPods, watches etc.
      if (!obj.model || !obj.grade) return;

      // FIX 2: normalise storage and grade to strings
      obj.storage = (obj.storage != null) ? String(obj.storage).trim() : '';
      obj.grade   = String(obj.grade).trim();

      data.push(obj);
    });
    return data;
  }

  /* ---- AUTOCOMPLETE ---- */

  window.tiShowDropdown = function () { tiFilterModels(); };

  window.tiFilterModels = function () {
    var input    = document.getElementById('ti-model-input');
    var dropdown = document.getElementById('ti-model-dd');
    var q        = input.value.toLowerCase();
    dropdown.innerHTML = '';
    var filtered = q
      ? allModels.filter(function (m) { return m.toLowerCase().indexOf(q) !== -1; })
      : allModels.slice(0, 14);
    if (!filtered.length) { dropdown.classList.remove('show'); return; }
    filtered.slice(0, 12).forEach(function (model) {
      var div         = document.createElement('div');
      div.className   = 'ti-dd-item';
      div.textContent = model;
      div.onmousedown = function (e) { e.preventDefault(); tiSelectModel(model); };
      dropdown.appendChild(div);
    });
    dropdown.classList.add('show');
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ti-ac')) document.getElementById('ti-model-dd').classList.remove('show');
  });

  function tiSelectModel(model) {
    selModel = model; selStorage = null; selGrade = null;
    document.getElementById('ti-model-input').value     = model;
    document.getElementById('ti-model-dd').classList.remove('show');
    document.getElementById('ti-sel-model').textContent = model;
    setNum(1, 'done'); setNum(2, 'active');
    renderStorage(); clearResult();
  }

  /* ---- STORAGE / SIZE ---- */

  function renderStorage() {
    var wrap = document.getElementById('ti-storage-wrap');
    wrap.innerHTML = '';

    var seen = {}, storages = [];
    products.filter(function (p) { return p.model === selModel; }).forEach(function (p) {
      if (!seen[p.storage]) { seen[p.storage] = true; storages.push(p.storage); }
    });

    // Non-empty storage values only (for buttons)
    var namedStorages = storages.filter(function (s) { return s; });

    namedStorages.sort(function (a, b) {
      // Sort MM sizes numerically; GB/TB by capacity
      var na = parseInt(a), nb = parseInt(b);
      if (isSizeVariant(a) && isSizeVariant(b)) return na - nb;
      return na * (a.indexOf('TB') !== -1 ? 1024 : 1) - nb * (b.indexOf('TB') !== -1 ? 1024 : 1);
    });

    // FIX 3: if no storage variants, hide step 2 and auto-select empty storage
    var storageStep = document.getElementById('ti-num-2').closest('.ti-step');
    var storageHead = storageStep.querySelector('.ti-step-title');

    if (namedStorages.length === 0) {
      storageStep.style.display = 'none';
      // Renumber step 3 to step 2 for the customer
      document.getElementById('ti-num-3').closest('.ti-step').querySelector('.ti-step-title').textContent = 'What condition is it in?';
      selStorage = ''; // match empty-string rows
      setNum(2, 'done');
      setNum(3, 'active');
      renderCondition();
      return;
    }

    storageStep.style.display = '';

    // FIX 4: rename step label to "What size?" for MM variants
    var allSizes = namedStorages.every(function (s) { return isSizeVariant(s); });
    storageHead.textContent = allSizes ? 'What size is it?' : 'How much storage?';

    namedStorages.forEach(function (s) {
      var btn       = document.createElement('button');
      btn.className = 'ti-chip';
      btn.textContent = s;
      btn.onclick   = function () { selectStorage(s, btn); };
      wrap.appendChild(btn);
    });

    resetCondition();
    setTimeout(function () { storageStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 80);
  }

  function selectStorage(s, btn) {
    selStorage = s; selGrade = null;
    document.querySelectorAll('#ti-storage-wrap .ti-chip').forEach(function (c) { c.classList.remove('selected'); });
    btn.classList.add('selected');
    document.getElementById('ti-sel-storage').textContent = s;
    setNum(2, 'done'); setNum(3, 'active');
    renderCondition(); clearResult();
    setTimeout(function () { document.getElementById('ti-num-3').closest('.ti-step').scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 80);
  }

  /* ---- CONDITION ---- */

  function resetCondition() {
    document.getElementById('ti-condition-wrap').innerHTML = '<span class="ti-placeholder">Select ' + (document.getElementById('ti-num-2').closest('.ti-step').style.display === 'none' ? 'a device' : 'storage') + ' first</span>';
    document.getElementById('ti-sel-grade').textContent = '';
    setNum(3, ''); selGrade = null;
  }

  function renderCondition() {
    var wrap = document.getElementById('ti-condition-wrap');
    wrap.innerHTML = '';

    var btn       = document.createElement('button');
    btn.className = 'ti-guide-btn';
    btn.id        = 'ti-guide-btn';
    btn.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> What grade is my device?';
    btn.onclick   = toggleGuide;
    wrap.appendChild(btn);

    var cards       = document.createElement('div');
    cards.className = 'ti-guide-cards';
    cards.id        = 'ti-guide-cards';

    [{ cls: 'ga', gcls: 'gr-a', letter: 'A', name: 'Excellent' },
     { cls: 'gb', gcls: 'gr-b', letter: 'B', name: 'Good' },
     { cls: 'gc', gcls: 'gr-c', letter: 'C', name: 'Fair' }].forEach(function (g) {
      var card      = document.createElement('div');
      card.className = 'ti-gc ' + g.cls;
      var checks    = GRADE_CHECKS[g.gcls].map(function (x) { return '<li>' + x + '</li>'; }).join('');
      card.innerHTML =
        '<div class="ti-gc-letter">' + g.letter + '</div>' +
        '<div class="ti-gc-name">'   + g.name   + '</div>' +
        '<ul class="ti-gc-checks">'  + checks   + '</ul>';
      cards.appendChild(card);
    });
    wrap.appendChild(cards);

    var chipRow       = document.createElement('div');
    chipRow.className = 'ti-chips';
    chipRow.id        = 'ti-grade-chips';

    var seen = {}, grades = [];
    products.filter(function (p) {
      return p.model === selModel && p.storage === selStorage;
    }).forEach(function (p) {
      if (!seen[p.grade]) { seen[p.grade] = true; grades.push(p.grade); }
    });
    grades.sort();

    grades.forEach(function (grade) {
      if (!grade) return;
      var meta        = GRADE_META[grade] || { label: grade.replace(/^(Unlocked|Grade)\s+/i, ''), cls: '' };
      var chip        = document.createElement('button');
      chip.className  = 'ti-chip ' + meta.cls;
      chip.textContent = meta.label;
      chip.dataset.grade = grade;
      chip.onclick    = function () { selectGrade(grade, chip); };
      chipRow.appendChild(chip);
    });
    wrap.appendChild(chipRow);
  }

  function toggleGuide() {
    var cards = document.getElementById('ti-guide-cards');
    var btn   = document.getElementById('ti-guide-btn');
    if (!cards) return;
    cards.classList.toggle('show');
    btn.classList.toggle('open');
  }

  function selectGrade(grade, chip) {
    selGrade = grade;
    document.querySelectorAll('#ti-grade-chips .ti-chip').forEach(function (c) { c.classList.remove('selected'); });
    chip.classList.add('selected');
    var meta = GRADE_META[grade] || { label: grade.replace(/^(Unlocked|Grade)\s+/i, '') };
    document.getElementById('ti-sel-grade').textContent = meta.label;
    setNum(3, 'done'); clearResult();
  }

  /* ---- QUOTE ---- */

  function calcPrice(model, cashPrice) {
    return premiumModels.indexOf(model) !== -1 ? cashPrice + 20 : Math.ceil(cashPrice / 10) * 10;
  }

  function fmtDate(d) {
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  window.tiGetQuote = function () {
    if (!selModel)            { flash(document.getElementById('ti-num-1').closest('.ti-step')); return; }
    if (selStorage === null)  { flash(document.getElementById('ti-num-2').closest('.ti-step')); return; }
    if (!selGrade)            { flash(document.getElementById('ti-num-3').closest('.ti-step')); return; }

    var p = null;
    for (var i = 0; i < products.length; i++) {
      if (products[i].model === selModel && products[i].storage === selStorage && products[i].grade === selGrade) {
        p = products[i]; break;
      }
    }
    if (!p) { alert('No price found for that combination - please try a different option'); return; }

    var price  = calcPrice(p.model, p.cashPrice);
    var today  = new Date();
    var expiry = new Date(today);
    expiry.setDate(expiry.getDate() + 7);

    // Build a clean display string for storage/size
    var storageMeta = p.storage
      ? (isSizeVariant(p.storage) ? p.storage : p.storage)
      : '';
    var gradeLabel  = (GRADE_META[p.grade] || { label: p.grade.replace(/^(Unlocked|Grade)\s+/i, '') }).label;
    var metaParts   = [storageMeta, gradeLabel].filter(function (x) { return x; });

    currentQuote = { model: p.model, storage: p.storage, grade: p.grade, gradeLabel: gradeLabel, storageMeta: storageMeta, price: price, today: today, expiry: expiry };

    document.getElementById('ti-r-device').textContent = p.model;
    document.getElementById('ti-r-meta').textContent   = metaParts.join(' \u00b7 ');
    document.getElementById('ti-r-amount').textContent = '\u00a3' + price.toFixed(2);
    document.getElementById('ti-r-date').textContent   = fmtDate(today);
    document.getElementById('ti-r-expiry').textContent = fmtDate(expiry);

    var result = document.getElementById('ti-result');
    result.classList.add('show');
    setTimeout(function () { result.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 60);
  };

  function clearResult() {
    document.getElementById('ti-result').classList.remove('show');
    currentQuote = null;
  }

  /* ---- HELPERS ---- */

  function setNum(n, state) {
    var el = document.getElementById('ti-num-' + n);
    if (!el) return;
    el.className   = 'ti-step-num';
    if (state) el.classList.add(state);
    el.textContent = (state === 'done') ? '\u2713' : String(n);
  }

  function flash(el) {
    if (!el) return;
    el.style.outline      = '2px solid #E60D67';
    el.style.borderRadius = '12px';
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    setTimeout(function () { el.style.outline = ''; }, 1500);
  }

  /* ---- STORE MODAL ---- */

  window.tiShowModal    = function () { document.getElementById('ti-overlay').classList.add('show'); document.body.style.overflow = 'hidden'; };
  window.tiCloseModal   = function () { document.getElementById('ti-overlay').classList.remove('show'); document.body.style.overflow = ''; };
  window.tiOverlayClick = function (e) { if (e.target === document.getElementById('ti-overlay')) tiCloseModal(); };

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') tiCloseModal(); });

  /* ---- CANT FIND TOGGLE ---- */

  window.tiToggleNF = function () {
    var body    = document.getElementById('ti-nf-body');
    var chevron = document.getElementById('ti-nf-chevron');
    body.classList.toggle('show');
    chevron.classList.toggle('open');
    if (body.classList.contains('show')) {
      setTimeout(function () { body.closest('.ti-notfound').scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 80);
    }
  };

  // Auto-open if Shopify returned after a successful form post
  (function () {
    if (document.querySelector('.ti-nf-success-shown')) {
      var body    = document.getElementById('ti-nf-body');
      var chevron = document.getElementById('ti-nf-chevron');
      if (body)    body.classList.add('show');
      if (chevron) chevron.classList.add('open');
    }
  })();

  /* ---- PRINT QUOTE ---- */

  window.tiPrintQuote = function () {
    if (!currentQuote) return;
    var q         = currentQuote;
    var issued    = fmtDate(q.today);
    var expires   = fmtDate(q.expiry);
    var priceStr  = '\u00a3' + q.price.toFixed(2);
    var metaParts = [q.storageMeta, q.gradeLabel].filter(function (x) { return x; });
    var metaStr   = metaParts.join(' \u00b7 ');

    var css =
      '* { box-sizing:border-box; margin:0; padding:0; }' +
      'body { font-family:Poppins,sans-serif; background:#fff; display:flex; justify-content:center; padding:30px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }' +
      '.receipt { width:320px; border:1.5px solid #e8edf3; border-radius:12px; overflow:hidden; }' +
      '.rt { background:#0f1923; color:#fff; padding:18px 20px; text-align:center; }' +
      '.rl { font-size:20px; font-weight:800; letter-spacing:0.08em; text-transform:uppercase; }' +
      '.rs { font-size:10px; color:rgba(255,255,255,0.5); letter-spacing:0.15em; text-transform:uppercase; margin-top:2px; }' +
      '.rp { background:#fff8fb; border-bottom:1.5px solid #e8edf3; padding:20px; text-align:center; }' +
      '.rlb { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:0.15em; color:#6b8499; margin-bottom:6px; }' +
      '.ra { font-size:52px; font-weight:800; color:#E60D67; letter-spacing:-0.04em; line-height:1; margin-bottom:8px; }' +
      '.rd { font-size:14px; font-weight:600; color:#0f1923; margin-bottom:3px; }' +
      '.rm { font-size:12px; color:#6b8499; }' +
      '.rdt { padding:14px 20px; border-bottom:1.5px solid #e8edf3; }' +
      '.rr { display:flex; justify-content:space-between; align-items:center; padding:5px 0; font-size:12px; }' +
      '.rrl { color:#6b8499; font-weight:500; }' +
      '.rrv { font-weight:600; color:#0f1923; }' +
      '.hi .rrv { color:#18a067; font-weight:700; }' +
      '.rf { padding:14px 20px; background:#f4f8fb; text-align:center; }' +
      '.rf p { font-size:10px; color:#6b8499; line-height:1.7; }' +
      '@media print { body { padding:10px; } }';

    var html =
      '<!DOCTYPE html><html><head>' +
      '<meta charset="utf-8">' +
      '<title>iLab Trade-In Quote</title>' +
      '<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&display=swap" rel="stylesheet">' +
      '<style>' + css + '</style>' +
      '</head><body>' +
      '<div class="receipt">' +
        '<div class="rt"><div class="rl">The iLab</div><div class="rs">Trade-In Quote</div></div>' +
        '<div class="rp">' +
          '<div class="rlb">We\'ll pay you</div>' +
          '<div class="ra">'  + priceStr  + '</div>' +
          '<div class="rd">'  + q.model   + '</div>' +
          '<div class="rm">'  + metaStr   + '</div>' +
        '</div>' +
        '<div class="rdt">' +
          '<div class="rr"><span class="rrl">Quote issued</span><span class="rrv">' + issued  + '</span></div>' +
          '<div class="rr hi"><span class="rrl">Valid until</span><span class="rrv">'  + expires + '</span></div>' +
          '<div class="rr"><span class="rrl">Where to go</span><span class="rrv">60 High Street, Barnstaple EX31 1JB</span></div>' +
        '</div>' +
        '<div class="rf"><p>No appointment needed. Just walk in and show us this quote.<br>Subject to device inspection. Final offer may vary if condition differs.</p></div>' +
      '</div>' +
      '</body></html>';

    var win = window.open('', '_blank');
    if (!win) { alert('Please allow pop-ups for this site to save your quote.'); return; }
    win.document.open();
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(function () { win.print(); }, 800);
  };

  /* ---- START ---- */

  init();

})();